import { IProductDetails } from "@/types/ProductTypes";
import { capitalize, getImageOrAcronym } from "@/lib/utils";

interface SupplierCardProps {
  product: IProductDetails;
}

const EVENTLY_SUPPLIER_URL = "https://evently.ph/users";

const SupplierCard = ({ product }: SupplierCardProps) => {
  const imageOrAcronym = getImageOrAcronym(
    product.title,
    product.product_images?.[0]?.file_url
  );
  const typeLabels =
    product.product_types
      ?.map(
        (type) =>
          type.product_type?.name || type.product_type_label || ""
      )
      .filter(Boolean) || [];

  const ownerName = [product.user?.first_name, product.user?.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {imageOrAcronym.type === "image" ? (
        <img
          src={imageOrAcronym.src}
          alt={product.title}
          className="w-full h-48 object-cover"
        />
      ) : (
        <div className="w-full h-48 flex items-center justify-center bg-primary-100">
          <span className="text-primary-600 font-bold text-4xl tracking-wide">
            {imageOrAcronym.text}
          </span>
        </div>
      )}

      <div className="p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2 line-clamp-2 capitalize">
          {capitalize(product.title)}
        </h3>

        {ownerName ? (
          <p className="text-sm text-gray-500 mb-3">{ownerName}</p>
        ) : null}

        {typeLabels.length > 0 ? (
          <div className="flex flex-wrap gap-2 mb-4">
            {typeLabels.map((label) => (
              <span
                key={label}
                className="inline-flex items-center bg-gray-100 rounded-full px-2.5 py-0.5 text-xs font-medium text-gray-800"
              >
                {capitalize(label)}
              </span>
            ))}
          </div>
        ) : null}

        <a
          href={`${EVENTLY_SUPPLIER_URL}/${product.user?.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full bg-primary-600 text-white text-center py-3 px-4 rounded-lg hover:bg-primary-700 transition-colors duration-200 font-medium"
        >
          Details
        </a>
      </div>
    </div>
  );
};

export default SupplierCard;
